/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

export const corpulsOrange = {
  main: '#fb7324',
  light: '#fed5bd',
  dark: '#f95616',
  contrastText: '#fff',
};

export const corpulsGreen = {
  main: '#80b823',
  light: '#d9eabd',
  dark: '#63a015',
  contrastText: '#fff',
};

export const corpulsBlue = {
  main: '#4a90e2',
  light: '#c9def6',
  dark: '#3273d6',
  contrastText: '#fff',
};

export const corpulsYellow = {
  main: '#F5A623',
};
